import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  SimpleChanges
} from '@angular/core';
import {SortableColumn} from "../../directive/sortable-column.directive";
import {Sort} from "@utility";

@Component({
  selector: 'app-sortable-table',
  templateUrl: './sortable-table.component.html',
  styleUrl: './sortable-table.component.scss'
})
export class SortableTableComponent {
  @ContentChild(SortableColumn, {static: false}) col?: SortableColumn;

  @ContentChildren(SortableColumn, {descendants: true}) columns: QueryList<SortableColumn> | undefined;
  @Input() cssClass?: string;
  @Input() items?: Array<any>;
  @Input() additionalItems?: Array<any>;
  @Output() onSort: EventEmitter<void> = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['items']?.currentValue) {
      this.columns?.forEach((sortableColumn: SortableColumn) => {
        sortableColumn.deactivate();
      })
    }
  }

  public sort(columnId?: string): void {
    if (this.items && columnId) {
      this.columns?.forEach((sortableColumn: SortableColumn) => {
        if (sortableColumn.id === columnId) {
          const sort: Sort = new Sort();
          this.items!.sort(sort.startSort(...sortableColumn.sortingParams));
          this.onSort.emit();
          sortableColumn.activate();
        } else {
          sortableColumn.deactivate();
        }
      })
    }
  }


}
